import t from "styled-components";
import e from "../../utils/colors.js";
import { device as r } from "../../utils/device.js";
const l = t.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: stretch;
  max-width: 350px;
  width: 100%;

  @media ${r.isMobile} {
    max-width: none;
  }
`, o = t.label`
  align-self: stretch;
  font-family: VIC;
  font-weight: 600;
  overflow-wrap: break-word;
  margin-bottom: 8px;
  color: ${e.blueGrey};
`, c = t(o)`
  font-weight: 400;
  margin-top: 8px;
  color: ${e.blueGrey75};
`, s = t(o)`
  color: ${e.red};
  margin-top: 8px;
  font-weight: 400;
`, p = t(o)`
  margin-top: 8px;
  font-weight: 400;
  text-decoration: underscore;
  color: ${e.brown};
  border: 0;
  text-decoration: underline;
  font-size: 1rem;
  text-align: left;
  padding: 0;
  cursor: pointer;
`, d = t.input`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  align-self: stretch;
  height: 46px;
  border-radius: 2px;
  font-size: 1rem;
  font-family: VIC;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.32px;
  outline: 0px !important;
  color: ${e.blueGrey};
  cursor: active;
  background-color: ${e.white};
  border: solid 1px ${e.blueGrey};
  padding: 0 16px;

  &[aria-invalid='true'] {
    border-color: ${e.red};
  }

  &[disabled] {
    background-color: ${e.darkGrey10};
    cursor: not-allowed;
    border: solid 1px ${e.darkGrey75};
  }

  &:active,
  &:focus {
    border-color: ${e.orange};
  }

  &[autocomplete="off"] {
    /* Disable native safari autofill suggestion */
    &::-webkit-contacts-auto-fill-button,
    &::-webkit-credentials-auto-fill-button {
      visibility: hidden;
      pointer-events: none;
      position: absolute;
      right: 0;
    }

    /* Hide webkit browsers native search clear button */
    &[type='search']::-webkit-search-decoration,
    &[type='search']::-webkit-search-cancel-button,
    &[type='search']::-webkit-search-results-button,
    &[type='search']::-webkit-search-results-decoration {
      -webkit-appearance: none;
    }
  }
`;
export {
  s as ErrorLabel,
  c as HintLabel,
  d as Input,
  o as Label,
  p as LinkLabel,
  l as Wrapper
};
